
import { Component, Vue } from "vue-property-decorator";
import KiraArtisHesaplayici from "./hesaplamalar/KiraArtisHesaplayici.vue";
import AracDegerKaybiHesaplayici from "./hesaplamalar/AracDegerKaybiHesaplayici.vue";
import KidemTazminatiHesaplayici from "./hesaplamalar/KidemTazminatiHesaplayici.vue";
import MahkemeHarciHesaplayici from "./hesaplamalar/MahkemeHarciHesaplayici.vue";
import TrafikCezasiHesaplayici from "./hesaplamalar/TrafikCezasiHesaplayici.vue";
import VekaletUcretiHesaplayici from "./hesaplamalar/VekaletUcretiHesaplayici.vue";

interface HesaplayiciItem {
  anahtar: string;
  baslik: string;
  kisaAciklama: string;
  detayAciklama: string;
  ikonBos: string;
  ikonDolu: string;
}

@Component({
  components: {
    KiraArtisHesaplayici,
    AracDegerKaybiHesaplayici,
    KidemTazminatiHesaplayici,
    MahkemeHarciHesaplayici,
    TrafikCezasiHesaplayici,
    VekaletUcretiHesaplayici,
  },
})
export default class Hesaplamalar extends Vue {
  aktifHesaplayici: string = "kira";

  hesaplayicilar: HesaplayiciItem[] = [
    {
      anahtar: "kira",
      baslik: "Kira Artışı",
      kisaAciklama: "Yeni kira tutarını hesaplayın.",
      detayAciklama:
          "Mevcut kira tutarı ve artış oranını girerek yeni kira tutarını hesaplayabilirsiniz.",
      ikonBos: "mdi-home-city-outline",
      ikonDolu: "mdi-home-city",
    },
    {
      anahtar: "arac",
      baslik: "Araç Değer Kaybı",
      kisaAciklama: "Hasar sonrası değer kaybı.",
      detayAciklama:
          "Araç değeri, hasar tutarı ve araç yaşı üzerinden tahmini değer kaybı hesaplanır.",
      ikonBos: "mdi-car-outline",
      ikonDolu: "mdi-car",
    },
    {
      anahtar: "kidem",
      baslik: "Kıdem Tazminatı",
      kisaAciklama: "Çalışma süresine göre kıdem.",
      detayAciklama:
          "Brüt maaş, çalışma süresi ve düzenli ödemeler üzerinden yaklaşık kıdem tazminatı hesaplanır.",
      ikonBos: "mdi-briefcase-outline",
      ikonDolu: "mdi-briefcase",
    },
    {
      anahtar: "mahkeme",
      baslik: "Mahkeme Harç / Gider",
      kisaAciklama: "Harç ve ek giderler.",
      detayAciklama:
          "Dava değeri, harç oranı ve ek giderler üzerinden toplam mahkeme maliyeti hesaplanır.",
      ikonBos: "mdi-gavel",
      ikonDolu: "mdi-gavel",
    },
    {
      anahtar: "trafik",
      baslik: "Trafik Cezası",
      kisaAciklama: "trafik cezası hesaplama.",
      detayAciklama:
          "Ceza türü ve ilgili bilgiler üzerinden trafik ceza tutarı hesaplanır.",
      ikonBos: "mdi-car-brake-alert",
      ikonDolu: "mdi-car-brake-alert",
    },
    {
      anahtar: "vekalet",
      baslik: "Vekâlet Ücreti",
      kisaAciklama: "Nispi / maktu vekâlet.",
      detayAciklama:
          "Dava tipine göre nispi veya maktu vekâlet ücreti yaklaşık olarak hesaplanır.",
      ikonBos: "mdi-scale-balance",
      ikonDolu: "mdi-scale-balance",
    },
  ];

  get aktifHesaplayiciBilgi(): HesaplayiciItem {
    const bulunan = this.hesaplayicilar.find(
        (h) => h.anahtar === this.aktifHesaplayici
    );
    return bulunan || this.hesaplayicilar[0];
  }

  aktifHesaplayiciDegistir(anahtar: string) {
    this.aktifHesaplayici = anahtar;
  }
}
